import { API } from 'apis';
import { Dispatch, SetStateAction } from 'react';
import { __API } from 'apis/api-routes';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import { message } from 'antd';
import { Enum } from 'core/domain';
import { TrackVoucherResponse } from 'core/domain/track-voucher/track-voucher';

export const getVoucherInfo = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<any>>,
    voucherCode: string,
    query?: string,
) => {
    setLoading(true);
    await getViaAuth<TrackVoucherResponse>(API.voucher.trackVoucher + `/${voucherCode}${query ? query : ''}`).then((response) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
        } else if (response.status === 404) {
            setData(undefined);
        }
    });
};

export const getUtopiaFilters = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>,
) => {
    setLoading(true);
    await getViaAuth<Enum[]>(API.enum.utopiaFilter)
        .then((response) => {
            setLoading(false);
            if (responseValidator(response.status)) {
                setData([{ id: -1, title: 'همه فیلتر ها' }, ...response.value]);
            }
        })
        .catch((error: any) => {
            setLoading(false);
        });
};

export const activateVoucher = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<any>>,
    voucherData: any,
) => {
    setLoading(true);
    await postViaAuth(API.perfectMoney.active, voucherData).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            message.success(response.message);
            setData(response.value);
        } else if (response.status === 404) {
            setData(undefined);
        }
    });
};

export const createVoucher = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<any>>,
    voucherData: any,
) => {
    setLoading(true);
    await postViaAuth(API.perfectMoney.create, voucherData).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            message.success(response.message);
            setData(response.value);
        } else if (response.status === 404) {
            setData(undefined);
        }
    });
};

export const getVoucherLogs = async (
    setLoading: Dispatch<React.SetStateAction<boolean>>,
    setData: Dispatch<React.SetStateAction<any>>,
    page: number,
    pageSize: number,
    query?: string,
) => {
    setLoading(true);
    await getViaAuth(`${API.perfectMoney.getAll}/${page}/${pageSize}${query || ''}`).then((response) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
        }
    });
};
